<div
  *ngIf="_controllers | findProperty : findPropFunction as property"
  class="flex-row border-bottom margin-bottom10"
>
  <div class="temp-box-title margin-right20 icon-left-text">
    {{ property[0].name | translate }}
  </div>
  <ion-button
    size="small"
    fill="outline"
    color="medium"
    class="ion-btn-pad-sm margin2 width-25"
    (click)="decrement()"
    >-</ion-button
  >
  <div
    *ngIf="targetValue || property[0]?.value; else novalue"
    class="temp-box-content"
  >
    <span class="temp-num">{{ targetValue || property[0]?.value }}</span
    ><span class="temp-unit">°C</span>
  </div>
  <ng-template #novalue>
    <div class="temp-box-content">
      <div class="no-info">{{ "No info" | translate }}</div>
    </div>
  </ng-template>
  <ion-button
    size="small"
    fill="outline"
    color="medium"
    class="ion-btn-pad-sm margin2 width-25"
    (click)="increment()"
    >+</ion-button
  >
</div>
